import { render, staticRenderFns } from "./PayrollUpload.vue?vue&type=template&id=3b797f6d&"
import script from "./PayrollUpload.vue?vue&type=script&lang=js&"
export * from "./PayrollUpload.vue?vue&type=script&lang=js&"
import style0 from "./PayrollUpload.vue?vue&type=style&index=0&id=3b797f6d&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports